import { useState } from "react";
import * as React from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/images/VBM_LOGO_FULL.png";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import CombiIcon from "@mui/icons-material/SpaTwoTone";
import Autocomplete from "@mui/material/Autocomplete";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import TocIcon from '@mui/icons-material/Toc';
import GridOnIcon from '@mui/icons-material/GridOn';
import ExposureIcon from '@mui/icons-material/Exposure';
import HouseIcon from '@mui/icons-material/OtherHouses';
import UploadIcon from '@mui/icons-material/FileUpload';
import UserIcon from '@mui/icons-material/PeopleAlt';
import GrassIcon from '@mui/icons-material/Grass';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import { IApplication } from "../interfaces/IApplication";
import { setBackgroundPath, setPageTitle } from "../slices/applicationSlice";
import { useAppDispatch } from "../hooks";
import { useEffect } from "react";
import ModuleMenu from "../components/ModuleMenu";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#666666' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  border: 0,
  borderRadius: 0,
  boxShadow: "none",
}));

const availableModules = [
  { label: "Patching", route: "/patching/dashboard" },
  { label: "Space Allocation", route: "/main/spaceallocationdashboard" },
  { label: "Tray Import", route: "/main/trayimportdashboard" },
  { label: "User Management", route: "/hr/usersdashboard" },
  { label: "Inventory", route: "/main/inventorydashboard" },
  { label: "Growing", route: "/main/growingdashboard" },
  { label: "Logistics", route: "/logistics/dashboard" },
  { label: "Invoicing", route: "/invoicing/dashboard" },
  { label: "Shipping", route: "/shipping/dashboard" },
  { label: "Purchase Orders", route: "/po/podashboard" },
];

export default function PatchingDashboard() {

  const dispatch = useAppDispatch();

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Patching Dashboard",
      backgroundPath: "/assets/images/patchingbg.jpg"
    }
    dispatch(setPageTitle(appState));
    dispatch(setBackgroundPath(appState));
  }, []);

  const [open, setOpen] = React.useState(false);
  const [combifixOpen, setCombifixOpen] = React.useState(false);
  const [manualCombifixOpen, setManualCombifixOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCombifixOpen = () => {
    setCombifixOpen(true);
  };

  const handleManualCombifixClose = () => {
    setManualCombifixOpen(false);
  };

  const handleManualCombifixOpen = () => {
    setManualCombifixOpen(true);
  };

  const handleCombifixClose = () => {
    setCombifixOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const [errorMessage, setErrorMessage] = useState({ error: "" });
  const [value, setValue] = React.useState<any | null>(availableModules[0]);
  let items = [];
  let history = useNavigate();

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#999" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));


  const moduleChanged = (event: any, newValue: any | null) => {
    console.log(newValue);
    navigate(newValue.route);
  };

  const navigate = useNavigate();

  return (
    <div className="wrapper">
      <section className="loginArea">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          paddingTop={5}
        >
          <img src={Logo} height="125px" />
        </Box>
        <Box display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={6}><Typography variant="h3">Patching Dashboard</Typography>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginTop={4}
          marginBottom={8}
        >
          <Paper
            component="form"
            sx={{
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 700,
              boxShadow: 12,
            }}
          >
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={availableModules}
              sx={{ width: "100%" }}
              renderInput={(params) => <TextField {...params} label="Select a Module" />}
              onChange={(e, newValue) => { moduleChanged(e, newValue) }}
            />
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton sx={{ p: "10px" }} aria-label="menu" onClick={handleClickOpen}>
              <MenuIcon />
            </IconButton>
          </Paper>
        </Box>

        <Box sx={{ flexGrow: 1, mt: 3 }}>
          <Grid container spacing={1} sx={{ padding: 2 }}>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<TocIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={() => navigate("/patching/patching-list")}
                >
                  <Typography variant="h5" fontWeight="700">PATCHING LISTS</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<GridOnIcon sx={{ width: 45, height: 45, color: "#89B219" }} />}
                  onClick={() => navigate("/patching/patching-production")}
                >
                  <Typography variant="h5" fontWeight="700">PATCHING PRODUCTION</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<CombiIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={handleCombifixOpen}
                >
                  <Typography variant="h5" fontWeight="700">PATCHING COMBIFIX</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<CombiIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                  onClick={handleManualCombifixOpen}
                >
                  <Typography variant="h5" fontWeight="700">PATCHING MANUAL</Typography>
                </Button>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                <Button
                  sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                  fullWidth
                  variant="contained"
                  size="large"
                  startIcon={<ExposureIcon sx={{ width: 50, height: 50, color: "#89B219" }} />}
                  onClick={() => navigate("/patching/patching-shortages-extras")}
                >
                  <Typography variant="h5" fontWeight="700" sx={{}}>SHORTAGES & EXTRAS</Typography>
                </Button>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </section>

      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          maxWidth='xl'
          fullWidth
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
            VBM Patching
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Box sx={{ flexGrow: 1, mt: 1 }}>
              <Grid container spacing={1} sx={{ padding: 2 }}>
                <Grid item xs={12} md={4}>
                  <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                    <Button
                      sx={{ minHeight: 100, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                      fullWidth
                      variant="contained"
                      size="large"
                      startIcon={<CombiIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                      onClick={() => navigate("/patching/dashboard")}
                    >
                      <Typography variant="h5" fontWeight="700">PATCHING</Typography>
                    </Button>
                  </Item>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                    <Button
                      sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                      fullWidth
                      variant="contained"
                      size="large"
                      startIcon={<HouseIcon sx={{ width: 45, height: 45, color: "#89B219" }} />}
                      onClick={() => navigate("/main/spaceallocationdashboard")}
                    >
                      <Typography variant="h5" fontWeight="700">SPACE ALLOCATION</Typography>
                    </Button>
                  </Item>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                    <Button
                      sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                      fullWidth
                      variant="contained"
                      size="large"
                      startIcon={<UploadIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                      onClick={() => navigate("/main/trayimportdashboard")}
                    >
                      <Typography variant="h5" fontWeight="700" sx={{}}>TRAY IMPORT</Typography>
                    </Button>
                  </Item>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                    <Button
                      sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                      fullWidth
                      variant="contained"
                      size="large"
                      startIcon={<UserIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                      onClick={() => navigate("/main/usersdashboard")}
                    >
                      <Typography variant="h5" fontWeight="700" sx={{}}>USER MANAGEMENT</Typography>
                    </Button>
                  </Item>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                    <Button
                      sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                      fullWidth
                      variant="contained"
                      size="large"
                      startIcon={<GrassIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                      onClick={() => navigate("/main/inventorydashboard")}
                    >
                      <Typography variant="h5" fontWeight="700" sx={{}}>INVENTORY</Typography>
                    </Button>
                  </Item>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                    <Button
                      sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                      fullWidth
                      variant="contained"
                      size="large"
                      startIcon={<SettingsIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                      onClick={() => navigate("/main/settingsdashboard")}
                    >
                      <Typography variant="h5" fontWeight="700" sx={{}}>SETTINGS</Typography>
                    </Button>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
        </BootstrapDialog>
      </div>
      <Dialog open={combifixOpen} onClose={handleCombifixClose} maxWidth='md' fullWidth>
        <DialogTitle>Select Combifix Generation</DialogTitle>
        <DialogContent>
          <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none', margin: 1 }}>
            <Button
              sx={{ minHeight: 100, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
              fullWidth
              variant="contained"
              size="large"
              startIcon={<CombiIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
              onClick={() => navigate("/patching/patching-combifix")}
            >
              <Typography variant="h5" fontWeight="700" sx={{}}>GENERATION 1</Typography>
            </Button>
          </Item>
          <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none', margin: 1 }}>
            <Button
              sx={{ minHeight: 100, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
              fullWidth
              variant="contained"
              size="large"
              startIcon={<CombiIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
              onClick={() => navigate("/patching/patching-combifix")}
            >
              <Typography variant="h5" fontWeight="700" sx={{}}>GENERATION 2</Typography>
            </Button>
          </Item>
        </DialogContent>
        <DialogActions>
          <Button size="large" variant="outlined" onClick={handleCombifixClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={manualCombifixOpen} onClose={handleManualCombifixClose} maxWidth='md' fullWidth>
        <DialogTitle>Select Manual Type</DialogTitle>
        <DialogContent>
          <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none', margin: 1 }}>
            <Button
              sx={{ minHeight: 100, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
              fullWidth
              variant="contained"
              size="large"
              startIcon={<CombiIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
              onClick={() => navigate("/patching/patching-combifix")}
            >
              <Typography variant="h5" fontWeight="700" sx={{}}>MANUAL</Typography>
            </Button>
          </Item>
          <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none', margin: 1 }}>
            <Button
              sx={{ minHeight: 100, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
              fullWidth
              variant="contained"
              size="large"
              startIcon={<CombiIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
              onClick={() => navigate("/patching/patching-combifix")}
            >
              <Typography variant="h5" fontWeight="700" sx={{}}>BLOW-OUT</Typography>
            </Button>
          </Item>
        </DialogContent>
        <DialogActions>
          <Button size="large" variant="outlined" onClick={handleManualCombifixClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          maxWidth='xl'
          fullWidth
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
            VBM Modules
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <ModuleMenu></ModuleMenu>
          </DialogContent>
        </BootstrapDialog>
      </div>


    </div>


  );
}
